export const sanitizeHref = (href: string): string => {
  if (!href) return href;

  if (
    href.startsWith("#") ||
    href.startsWith("https") ||
    href.startsWith("http") ||
    href.startsWith("www")
  )
    return href;

  return `/${href.replace(/^\/|\/$/g, "")}`;
};
